export const getDistrictCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const getDistrictUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
